import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { sessionEnded, sessionLeft, signalingRoomJoined } from 'features/room/actions';
import { TimerSliceState } from 'features/timer/types';

const initialState: TimerSliceState = {
  enabled: false,
  totalSeconds: 0,
  isActive: false,
};

const cleanupTimerState = (state: TimerSliceState) => {
  state.enabled = false;
  state.totalSeconds = 0;
  state.isActive = false;
};

export const timerSlice = createSlice({
  name: 'timer',
  initialState,
  reducers: {
    // TODO placeholders for v2
    timerStarted: (
      state,
      action: PayloadAction<{
        durationSeconds: number;
      }>
    ) => {
      state.enabled = true;
      state.totalSeconds = action.payload.durationSeconds;
      state.isActive = true;
    },

    timerStopped: (state) => {
      cleanupTimerState(state);
    },

    timerPaused: (state) => {
      if (state.enabled) {
        state.isActive = false;
      }
    },

    timerResumed: (state) => {
      if (state.enabled) {
        state.isActive = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signalingRoomJoined, (state, action) => {
        cleanupTimerState(state);

        // Only enable timer if we have a valid countdown
        const { endSessionSecondsRemaining } = action.payload;
        if (endSessionSecondsRemaining && endSessionSecondsRemaining > 0) {
          state.enabled = true;
          state.isActive = true;
          state.totalSeconds = endSessionSecondsRemaining;
        }
      })
      .addCase(sessionLeft, (state) => {
        cleanupTimerState(state);
      })
      .addCase(sessionEnded, (state) => {
        cleanupTimerState(state);
      });
  },
});

export const { timerStarted, timerStopped, timerPaused, timerResumed } = timerSlice.actions;

export const selectTimerEnabled = (state: RootState) => state.timer.enabled;
export const selectTimerActive = (state: RootState) => state.timer.isActive;
export const selectTimerTotalSeconds = (state: RootState) => state.timer.totalSeconds;

export default timerSlice.reducer;
